var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2002 4.50001C7.2002 3.71301 7.83819 3.07501 8.6252 3.07501H15.3752C16.1622 3.07501 16.8002 3.71301 16.8002 4.50001V11.25C16.8002 12.037 16.1622 12.675 15.3752 12.675H8.62519C7.83819 12.675 7.2002 12.037 7.2002 11.25V4.50001ZM8.6252 4.42501C8.58377 4.42501 8.5502 4.45859 8.5502 4.50001V11.25C8.5502 11.2914 8.58377 11.325 8.62519 11.325H15.3752C15.4166 11.325 15.4502 11.2914 15.4502 11.25V4.50001C15.4502 4.45859 15.4166 4.42501 15.3752 4.42501H8.6252Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0752 12.75C3.0752 11.963 3.71319 11.325 4.5002 11.325H11.2502C12.0372 11.325 12.6752 11.963 12.6752 12.75V19.5C12.6752 20.287 12.0372 20.925 11.2502 20.925H4.5002C3.71319 20.925 3.0752 20.287 3.0752 19.5V12.75ZM4.5002 12.675C4.45877 12.675 4.4252 12.7086 4.4252 12.75V19.5C4.4252 19.5414 4.45877 19.575 4.5002 19.575H11.2502C11.2916 19.575 11.3252 19.5414 11.3252 19.5V12.75C11.3252 12.7086 11.2916 12.675 11.2502 12.675H4.5002Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3252 12.75C11.3252 11.963 11.9632 11.325 12.7502 11.325H19.5002C20.2872 11.325 20.9252 11.963 20.9252 12.75V19.5C20.9252 20.287 20.2872 20.925 19.5002 20.925H12.7502C11.9632 20.925 11.3252 20.287 11.3252 19.5V12.75ZM12.7502 12.675C12.7088 12.675 12.6752 12.7086 12.6752 12.75V19.5C12.6752 19.5414 12.7088 19.575 12.7502 19.575H19.5002C19.5416 19.575 19.5752 19.5414 19.5752 19.5V12.75C19.5752 12.7086 19.5416 12.675 19.5002 12.675H12.7502Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.dd3a33e41141f22940a22cfb0587ba10.svg";
export { ForwardRef as ReactComponent };